import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import i18n from './i18n'
import store from './store'
import global from '@/utils/global'
import preventReClick from '@/utils/plugins';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/base/base.css'
import commonUtil from '@/utils/common';
//复制功能依赖
import VueClipboard from "vue-clipboard2";
//浏览器打印功能
//import Print from 'vue-print-nb'
Vue.prototype.$EventBus = new Vue()
Vue.use(ElementUI)
Vue.use(api)
Vue.use(VueClipboard);
Vue.prototype.global = global
Vue.prototype.commonUtil = commonUtil
// Vue.use(Print);

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js